export const COPY = {
  heading: 'Millions of developers and businesses call GitHub home',
  description:
    'Whether you’re scaling your development process or just learning how to code, GitHub is where you belong. Join the world’s most widely adopted AI-powered developer platform to build the technologies that redefine what’s possible.',
  cta1: {
    label: 'Sign up for GitHub',
    url: '/signup?source=form-home-signup',
  },
  cta2: {
    label: 'Try GitHub Copilot',
    subLabel: '30 days free',
    url: '/features/copilot',
  },
  visual: {
    url: {
      copilot: '/images/modules/site/home24/cta/mascots-copilot.webp',
      mona: '/images/modules/site/home24/cta/mascots-mona.webp',
      ducky: '/images/modules/site/home24/cta/mascots-ducky.webp',
      glowStart: '/images/modules/site/home24/cta/mascots-glow-start.webp',
      glowEnd: '/images/modules/site/home24/cta/mascots-glow-end.webp',
    },
    alt: 'A subtle purple glow fades in as Mona the Octocat, Copilot, and Ducky dramatically fall into place next to one another while gazing optimistically into the distance.',
  },
}
